// The smart-margin shield mark, inline so it inherits currentColor sizing and needs no
// network round-trip. Mirrors public/favicon.svg: a shield (protection) with an upward
// trend line (the financial side of the brand).

export function BrandMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 64 64"
      className={className}
      role="img"
      aria-label="smart-margin"
      fill="none"
    >
      <path
        d="M32 10 L50 17 V32 C50 43 42 50 32 54 C22 50 14 43 14 32 V17 Z"
        fill="var(--primary)"
      />
      <path
        d="M22 38 L29 31 L34 35 L43 24"
        fill="none"
        stroke="#ffffff"
        strokeWidth="3.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="43" cy="24" r="2.6" fill="#ffffff" />
    </svg>
  );
}
